import { useFlag } from '@calendly/feature-check-react'
import { useSelector } from 'react-redux'

import {
  isReportingDashboardFeatureEnabledSelector,
  ownerOrAdminCanViewReportingSelector,
  userGroupAdminCanViewReportingSelector
} from '../selectors'

export const useCheckReportingFeaturesEnabled = () => {
  const ownerOrAdminCanViewReporting = useSelector(ownerOrAdminCanViewReportingSelector)
  const userGroupAdminCanViewReporting = useSelector(userGroupAdminCanViewReportingSelector)
  const isEndUserAnalyticsFeatureFlagOn = useFlag('reporting_end_user_analytics_feature')
  const isUpcomingMeetingDataFeatureFlagOn = useFlag('org_expansion_upcoming_meeting_data_feature')
  const isAvailabilityAndCapacityFeatureFlagOn = useFlag('admin_console_adminavailabilityandcapacity')
  const isNewEmptyStatesFlagOn = useFlag('activation_q3')

  /**
  * Checks the billing feature key for the reporting dashboard
  * @type {boolean}
  */
  const isReportingDashboardBillingEnabled = useSelector(isReportingDashboardFeatureEnabledSelector)

  /**
   * Checks if end users have access to the reporting dashboard
   * @type {boolean}
   */
  const isReportingDashboardEnabledForEndUsers = isNewEmptyStatesFlagOn ? true : isEndUserAnalyticsFeatureFlagOn

  /**
   * Checks the user role and feature flag for allowing access to the reporting dashboard
   * @type {boolean}
   */
  const isReportingDashboardEnabled = (
    ownerOrAdminCanViewReporting || userGroupAdminCanViewReporting || isReportingDashboardEnabledForEndUsers
  )

  /**
   * Checks for the feature flag in addition to access rules for the reporting dashboard
   * @type {boolean}
   */
  const isUpcomingMeetingDataFeatureEnabled = isReportingDashboardEnabled && isUpcomingMeetingDataFeatureFlagOn

  /**
   * Checks for the feature flag in addition to access rules for the reporting dashboard
   * @type {boolean}
   */
  const isAvailabilityAndCapacityFeatureEnabled = isReportingDashboardEnabled && isAvailabilityAndCapacityFeatureFlagOn

  return {
    isReportingDashboardBillingEnabled,
    isReportingDashboardEnabled,
    isReportingDashboardEnabledForEndUsers,
    isUpcomingMeetingDataFeatureEnabled,
    isAvailabilityAndCapacityFeatureEnabled
  }
}
